import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'qwiko-auth-nav',
  imports: [RouterModule],
  templateUrl: './auth-nav.component.html',
  styleUrl: './auth-nav.component.scss',
})
export class AuthNavComponent {}
